import { render } from "./EtatCommandesParUtilisateurPage.vue?vue&type=template&id=f0f96de6&ts=true"
import script from "./EtatCommandesParUtilisateurPage.vue?vue&type=script&lang=ts"
export * from "./EtatCommandesParUtilisateurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__